<template>
  <LazyOrganismsNavbar />
  <div class="kg-content container">
    <slot />
  </div>
</template>
